/**
 * Тур по странице SubUsers (Підкористувачі).
 * Знакомит пользователя с функциями управления подпользователями и распределением прав доступа.
 * ВАЖНО: Тур работает только на больших экранах (>= 769px).
 */
export default {
  id: 'subusers-page',
  name: 'help.tours.subusers.name',
  description: 'help.tours.subusers.description',

  options: {
    showProgress: true,
    allowClose: true,
    stagePadding: 12,
    stageRadius: 8,
  },

  steps: [
    // Шаг 1: Приветствие
    {
      element: '.page-title',
      titleKey: 'help.tours.subusers.welcome.title',
      descriptionKey: 'help.tours.subusers.welcome.description',
      side: 'bottom',
      align: 'start',
    },
    // Шаг 2: Кнопка создания подпользователя
    {
      element: '.btn.btn--primary',
      titleKey: 'help.tours.subusers.createButton.title',
      descriptionKey: 'help.tours.subusers.createButton.description',
      side: 'bottom',
      align: 'end',
    },
    // Шаг 3: Журнал активности
    {
      element: '.btn.btn--secondary',
      titleKey: 'help.tours.subusers.activityLog.title',
      descriptionKey: 'help.tours.subusers.activityLog.description',
      side: 'bottom',
      align: 'end',
    },
    // Шаг 4: Статистика и фильтр по статусу
    {
      element: '.stats-row',
      titleKey: 'help.tours.subusers.stats.title',
      descriptionKey: 'help.tours.subusers.stats.description',
      side: 'bottom',
      align: 'start',
    },
    // Шаг 5: Поиск
    {
      element: '.search-bar',
      titleKey: 'help.tours.subusers.search.title',
      descriptionKey: 'help.tours.subusers.search.description',
      side: 'bottom',
      align: 'end',
    },
    // Шаг 6: Список подпользователей
    {
      element: '.sub-users-grid',
      titleKey: 'help.tours.subusers.usersList.title',
      descriptionKey: 'help.tours.subusers.usersList.description',
      side: 'top',
      align: 'center',
    },
    // Шаг 7: Карточка подпользователя
    {
      element: '.user-card',
      titleKey: 'help.tours.subusers.userCard.title',
      descriptionKey: 'help.tours.subusers.userCard.description',
      side: 'left',
      align: 'center',
    },
    // Шаг 8: Информация о пользователе
    {
      element: '.user-card__main',
      titleKey: 'help.tours.subusers.userInfo.title',
      descriptionKey: 'help.tours.subusers.userInfo.description',
      side: 'left',
      align: 'start',
    },
    // Шаг 9: Действия с карточкой (редактирование, удаление)
    {
      element: '.user-card__actions',
      titleKey: 'help.tours.subusers.cardActions.title',
      descriptionKey: 'help.tours.subusers.cardActions.description',
      side: 'left',
      align: 'end',
      expandSelector: '.user-card .expand-btn', // Автоматично розгорнути картку
    },
  ],
}
